/* ============================================================
   VD Real Results — "See the difference yourself" carousel
   • Native scroll-snap track, one slide per view.
   • Endless loop: the slide nearest an end is moved to the other end (the scroll
     position is shifted by the same amount, so nothing visibly moves), so there is
     always a neighbour to slide to. Next on the last slide keeps sliding the same
     way into the first; prev on the first slides in from the left.
   • Prev / next buttons and the desktop "See more" cue step one slide; the progress
     indicator (active bar + dots) is built from the slide count.
   Vanilla JS, no deps, idempotent, theme-editor aware.
   ============================================================ */
(function () {
  'use strict';

  if (window.__vdRrdLoaded) return;
  window.__vdRrdLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    root.querySelectorAll('[data-vd-rrd]').forEach(function (section) {
      if (section.dataset.vdRrdInit === '1') return;
      section.dataset.vdRrdInit = '1';

      var track = section.querySelector('[data-vd-rrd-track]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-vd-rrd-slide]'));
      var progress = section.querySelector('[data-vd-rrd-progress]');
      var prev = section.querySelector('[data-vd-rrd-prev]');
      var nexts = Array.prototype.slice.call(section.querySelectorAll('[data-vd-rrd-next]'));
      if (!track || !slides.length) return;

      var count = slides.length;
      var pips = [];
      var current = -1;
      var activeSlide = null;
      var resizing = false;
      var touching = false;
      var settleTimer;

      /* Slides get moved around, so each keeps its place in the editor order. */
      slides.forEach(function (slide, i) { slide.dataset.vdRrdIndex = String(i); });

      function buildProgress() {
        if (!progress) return;
        progress.innerHTML = '';
        pips = slides.map(function () {
          var pip = document.createElement('span');
          pip.className = 'vd-rrd__pip';
          progress.appendChild(pip);
          return pip;
        });
      }

      function maxScroll() { return track.scrollWidth - track.clientWidth; }

      function slideLeft(slide) {
        /* The track is the slides' offset parent, so offsetLeft is track-relative. */
        return Math.min(slide.offsetLeft, maxScroll());
      }

      /* Position in the current DOM order of the slide nearest the viewport start. */
      function nearest() {
        var x = track.scrollLeft;
        var best = 0;
        for (var i = 1; i < count; i++) {
          if (Math.abs(slideLeft(slides[i]) - x) < Math.abs(slideLeft(slides[best]) - x)) best = i;
        }
        return best;
      }

      /* Move a slide to the other end without changing what is on screen. Snapping is
         switched off meanwhile: browsers re-snap after a layout change on their own
         schedule, which would otherwise be added on top of the shift below. */
      function rotate(toFront) {
        var anchor = slides[nearest()];
        var offset = track.scrollLeft - anchor.offsetLeft;
        track.style.scrollSnapType = 'none';
        if (toFront) {
          var last = slides.pop();
          slides.unshift(last);
          track.insertBefore(last, track.firstChild);
        } else {
          var first = slides.shift();
          slides.push(first);
          track.appendChild(first);
        }
        track.scrollLeft = anchor.offsetLeft + offset;
        void track.offsetWidth;
        track.style.scrollSnapType = '';
      }

      function go(slide) {
        track.scrollTo({ left: slideLeft(slide), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      function step(dir) {
        var i = nearest();
        if (dir > 0 && i === count - 1) rotate(false);
        if (dir < 0 && i === 0) rotate(true);
        var target = slides[nearest() + dir];
        if (!target) return;
        /* Let the shifted scroll position paint before the slide animation starts. */
        requestAnimationFrame(function () { go(target); });
      }

      function update() {
        /* While the window resizes the browser shifts the scroll position by itself;
           the slide that was showing is restored afterwards, so don't follow the shift. */
        if (resizing) return;
        activeSlide = slides[nearest()];
        var i = Number(activeSlide.dataset.vdRrdIndex);
        if (i === current) return;
        current = i;
        pips.forEach(function (pip, n) { pip.classList.toggle('is-active', n === i); });
        slides.forEach(function (slide) {
          if (Number(slide.dataset.vdRrdIndex) === i) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
      }

      /* Make sure the slide on screen has a neighbour on both sides, so the next swipe
         or click keeps going. Nothing moves on screen. */
      function ensureNeighbours() {
        if (count < 3) return;
        var i = nearest();
        if (i === 0) rotate(true);
        else if (i === count - 1) rotate(false);
      }

      /* Once scrolling stops (swipe or button). */
      function settle() {
        if (touching) { settleTimer = setTimeout(settle, 140); return; }
        ensureNeighbours();
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      nexts.forEach(function (btn) {
        btn.addEventListener('click', function () { step(1); });
      });

      /* A new swipe can start before the last one has settled (quick flicks): do it before
         the finger moves, so there is never a dead end. */
      track.addEventListener('touchstart', function () { touching = true; ensureNeighbours(); }, { passive: true });
      track.addEventListener('touchend', function () { touching = false; }, { passive: true });
      track.addEventListener('touchcancel', function () { touching = false; }, { passive: true });

      var ticking = false;
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 140);
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        resizing = true;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          /* Slide widths changed: re-snap to the slide that was showing. */
          track.scrollTo({ left: slideLeft(activeSlide), behavior: 'auto' });
          resizing = false;
          update();
        }, 150);
      });

      /* Theme editor: bring the selected slide into view. */
      section.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target);
        if (i > -1) track.scrollTo({ left: slideLeft(slides[i]) });
      });

      /* Start on the first slide with the last one waiting before it. Done once the
         page has its layout, so the measured slide positions are the real ones. */
      var primed = false;
      function prime() {
        if (primed || count < 2) return;
        if (!track.clientWidth) { setTimeout(prime, 200); return; }
        primed = true;
        rotate(true);
        update();
      }

      buildProgress();
      update();
      if (document.readyState === 'complete') prime();
      else window.addEventListener('load', prime);
    });
  }

  function initAll(scope) {
    initCarousel(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
